import * as at from './actionTypes';

const INITIAL_STATE = {
	email: '',
	loading: false,
	error: '',
	surveyCompleted: false,
	duplicateEntry: false
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
		case at.EMAIL_CHANGED:
			const email = action.payload;
			return { ...state, email }
		case at.EMAIL_ADD:
			return { ...state, loading: true }
		case at.EMAIL_ADD_SUCCESS:
			let newState = { ...state, error: '', loading: false };
			if (action.payload) {
				newState.surveyCompleted = action.payload.surveyCompleted;
				newState.duplicateEntry = action.payload.inWaitingList;
			}
			return newState;
		case at.EMAIL_ADD_FAILURE:
			return { ...state, loading: false, error: action.payload };
		case at.SURVEY_SUBMIT:
			return { ...state, loading: true }
		case at.SURVEY_SUBMIT_FAILURE:
			return INITIAL_STATE
		case at.SURVEY_SUBMIT_SUCCESS:
			return { ...INITIAL_STATE, surveyCompleted: true }
		case at.SIGNUP_COMPLETE:
			return INITIAL_STATE
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/LandingFlow/reducer.js